"use client";

import dynamic from "next/dynamic";
import { storyblokEditable } from "@storyblok/react/rsc";
import { useAuth } from "@clerk/nextjs";

import { GridContainer } from "@/components/layout/GridContainer";
import { VideoSkeleton } from "@/components/layout/Skeleton";
import { useConsent } from "@/lib/hooks/useConsent";
import type { AssetStoryblok } from "@/component-types-sb";

const MuxPlayer = dynamic(() => import("@mux/mux-player-react"), {
  ssr: false,
  loading: () => <VideoSkeleton className="w-full h-full" />,
});

type VideoSectionStoryblok = {
  playback_id: string;
  title?: string;
  thumbnail?: AssetStoryblok;
  thumbnail_time?: number;
  _uid: string;
  component: "video_section";
};

type VideoSectionProps = {
  blok: VideoSectionStoryblok;
};

const VideoSection = ({ blok }: VideoSectionProps) => {
  const { userId } = useAuth();
  const { statistics } = useConsent();

  if (!blok.playback_id) return null;

  return (
    <div {...storyblokEditable(blok)}>
      <GridContainer>
        <div className="col-span-12 md:my-8 md:col-span-10 md:col-start-2 lg:col-span-10 lg:col-start-2 aspect-video rounded-3xl overflow-hidden">
          <MuxPlayer
            streamType="on-demand"
            playbackId={blok.playback_id}
            {...(blok.thumbnail?.filename && {
              poster: blok.thumbnail.filename,
            })}
            {...(blok.thumbnail_time && { thumbnailTime: blok.thumbnail_time })}
            metadata={{
              video_title: blok.title,
              viewer_user_id: userId,
            }}
            preload="auto"
            forwardSeekOffset={0}
            backwardSeekOffset={0}
            className="w-full h-full object-cover"
            style={
              {
                "--media-object-fit": "cover",
                "--media-border-radius": "32px",
              } as React.CSSProperties
            }
            disableCookies={!statistics}
            accentColor="#FDFD92"
          />
        </div>
      </GridContainer>
    </div>
  );
};

export default VideoSection;
